var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKbLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 37,
    viewBox: "0 0 168 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3001_146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0611 37.0011H1.23438L18.6483 19.4854L36.0611 37.0011Z",
    fill: "#B61D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6561 18.5011L0.242188 36.0192V0.985352L17.6561 18.5011Z",
    fill: "#B61D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0611 0L18.6483 17.5181L1.23438 0H36.0611Z",
    fill: "#B61D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9541 20.306L46.6369 21.7552V25.6476H43.7969V11.3623H46.6369V17.8837L52.4611 11.3623H56.0838L49.807 18.2564L56.3517 25.6464H52.647L47.9541 20.306Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3261 15.0864V25.6441H64.6501V24.3819C63.8062 25.3132 62.6332 25.8926 61.234 25.8926C58.3109 25.8926 56.1094 23.5122 56.1094 20.3653C56.1094 17.2184 58.3121 14.8379 61.234 14.8379C62.6332 14.8379 63.8062 15.4173 64.6501 16.3486V15.0864H67.3261ZM64.6501 20.3653C64.6501 18.7094 63.4148 17.446 61.7478 17.446C60.1015 17.446 58.8662 18.7082 58.8662 20.3653C58.8662 22.0223 60.1015 23.2846 61.7478 23.2846C63.4148 23.2846 64.6501 22.0223 64.6501 20.3653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7507 20.3653C80.7507 23.5122 78.5687 25.8926 75.6468 25.8926C74.2476 25.8926 73.0746 25.3341 72.2307 24.3819V29.5783H69.5547V15.0864H72.2307V16.3486C73.0746 15.3964 74.2476 14.8379 75.6468 14.8379C78.5699 14.8379 80.7507 17.2195 80.7507 20.3653ZM77.9927 20.3653C77.9927 18.7094 76.7782 17.446 75.1111 17.446C73.4649 17.446 72.2296 18.7082 72.2296 20.3653C72.2296 22.0223 73.4649 23.2846 75.1111 23.2846C76.7793 23.2846 77.9927 22.0223 77.9927 20.3653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0312 11.8575C82.0312 10.9053 82.7724 10.1807 83.7191 10.1807C84.6657 10.1807 85.4069 10.9053 85.4069 11.8575C85.4069 12.8097 84.6657 13.5342 83.7191 13.5342C82.7724 13.5342 82.0312 12.8097 82.0312 11.8575ZM82.3811 15.0868H85.0571V25.6445H82.3811V15.0868Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0697 17.5509V21.9391C91.0697 22.8298 91.5638 23.285 92.5104 23.285C93.0461 23.285 93.4986 23.1189 93.8889 22.9331V25.4379C93.3128 25.7479 92.7159 25.8931 91.9332 25.8931C89.525 25.8931 88.3936 24.4857 88.3936 22.3734V17.5497H86.7266V15.0868H88.3936V12.416H91.0697V15.0868H93.8889V17.5497H91.0697V17.5509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.506 15.0864V25.6441H103.83V24.3819C102.986 25.3132 101.813 25.8926 100.414 25.8926C97.4906 25.8926 95.2891 23.5122 95.2891 20.3653C95.2891 17.2184 97.4906 14.8379 100.414 14.8379C101.813 14.8379 102.986 15.4173 103.83 16.3486V15.0864H106.506ZM103.831 20.3653C103.831 18.7094 102.596 17.446 100.929 17.446C99.2823 17.446 98.0471 18.7082 98.0471 20.3653C98.0471 22.0223 99.2823 23.2846 100.929 23.2846C102.596 23.2846 103.831 22.0223 103.831 20.3653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.727 10.7402H111.403V25.6456H108.727V10.7402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.946 21.7761C129.946 24.0323 128.238 25.6476 125.954 25.6476H118.812V11.3623H125.481C127.6 11.3623 129.247 12.8939 129.247 15.0062C129.247 16.352 128.547 17.5318 127.6 18.0706C128.979 18.5665 129.946 20.0784 129.946 21.7761ZM121.569 13.9297V17.0766H124.78C125.624 17.0766 126.323 16.3938 126.323 15.5032C126.323 14.6125 125.665 13.9297 124.78 13.9297H121.569ZM127.024 21.2791C127.024 20.2851 126.262 19.4989 125.254 19.4989H121.571V23.0801H125.254C126.262 23.0801 127.024 22.2928 127.024 21.2791Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.607 15.0864V25.6441H139.931V24.3819C139.087 25.3132 137.915 25.8926 136.515 25.8926C133.592 25.8926 131.391 23.5122 131.391 20.3653C131.391 17.2184 133.592 14.8379 136.515 14.8379C137.915 14.8379 139.087 15.4173 139.931 16.3486V15.0864H142.607ZM139.931 20.3653C139.931 18.7094 138.696 17.446 137.029 17.446C135.383 17.446 134.147 18.7082 134.147 20.3653C134.147 22.0223 135.383 23.2846 137.029 23.2846C138.697 23.2846 139.931 22.0223 139.931 20.3653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.958 18.9368V25.644H152.282V19.8065C152.282 18.3782 151.377 17.447 149.976 17.447C148.515 17.447 147.528 18.3991 147.528 19.8483V25.6451H144.852V15.0874H147.528V16.2672C148.351 15.3359 149.503 14.8389 150.862 14.8389C153.332 14.8377 154.958 16.453 154.958 18.9368Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.696 22.0017L159.77 23.0166V25.6456H157.094V10.7402H159.77V19.4145L163.64 15.0878H167.097L162.59 19.973L167.241 25.6456H163.741L160.696 22.0017Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3001_146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 37,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKbLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/kb-logo.afcfaa2ee006673a82693e9ab3a58f7d.svg";